import { render, staticRenderFns } from "./Dailytask.vue?vue&type=template&id=4baa0fc9&scoped=true"
import script from "./Dailytask.vue?vue&type=script&lang=js"
export * from "./Dailytask.vue?vue&type=script&lang=js"
import style0 from "./Dailytask.vue?vue&type=style&index=0&id=4baa0fc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baa0fc9",
  null
  
)

export default component.exports